import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom'; // useHistory를 사용하여 경로 변경
import Select from 'react-select';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import images from '../../assets';
import { SearchMenuV2, SearchBaseV2 } from '../topBar/SearchMenu';
import apiClient from '../../_utils/axios';
import slangKo from '../../json/slang_ko';
import slangEn from '../../json/slang_en';
import { useSearch } from '../../hooks/useSearch';

const searchStyle = {
  control: (base) => ({
    ...base,
    border: 0,
    boxShadow: 'none',
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isFocused ? '#eee' : isSelected ? '#eee' : '#fff',
    color: '#000',
    cursor: 'default',
  }),
};

export const Search = () => {
  const { state, actions } = useSearch();
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
      <SearchMenuV2>
        <SearchBaseV2>
          <Button size="small" style={{ minWidth: 40 }} onClick={() => actions.goSearch(state.data.searchkey)}>
            <img alt="" style={{ paddingRight: '15px' }} src={images.topbar_search} />
          </Button>
          <div style={{ width: '100%' }}>
            <Select
              options={state.data.keywordList}
              placeholder={state.data.placeholder}
              components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
              styles={searchStyle}
              noOptionsMessage={() => t('search_no_data')}
              onChange={(e) => actions.goSearch(e.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && state.data.searchkey.length > 0) {
                  actions.goSearch(state.data.searchkey);
                }
              }}
              onInputChange={(value) => {
                actions.setData({ searchkey: value });
              }}
            />
          </div>
          <Button
            size="small"
            style={{
              minWidth: 40,
              marginRight: '8px',
              visibility: state.data.searchkey.length > 0 ? 'visible' : 'hidden',
            }}
            onClick={() => {
              actions.setData({ searchkey: '', keywordList: [] });
            }}
          >
            <img alt="" src={images.icon_close} />
          </Button>
        </SearchBaseV2>
      </SearchMenuV2>
    </div>
  );
};

export default Search;
